export default "<div class=\"matero-auth-container\">\n  <router-outlet></router-outlet>\n</div>\n"